import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import './Navbar.css';

export default function Navbar() {
  const { user, logout, isBuyer } = useAuth();
  const { totalItems } = useCart();
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  const handleLogout = async () => { await logout(); navigate('/'); };
  const isHome = location.pathname === '/';
  // Fix #10: default to solid unless we are on home AND not yet scrolled
  const isTransparent = isHome && !scrolled;

  return (
    <nav className={`navbar ${isTransparent ? 'navbar-transparent' : 'navbar-solid'} ${menuOpen ? 'navbar-open' : ''}`}>
      <div className="navbar-inner">
        <Link to="/" className="navbar-logo">
          ElevenNorth <span>&amp; Co.</span>
        </Link>

        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link to="/catalogue" className="nav-link">Catalogue</Link>
          <Link to="/catalogue?category=women" className="nav-link">Women</Link>
          <Link to="/catalogue?category=men" className="nav-link">Men</Link>
          <Link to="/catalogue?category=children" className="nav-link">Children</Link>
          <Link to="/contact" className="nav-link">Contact</Link>
        </div>

        <div className="navbar-actions">
          {isBuyer && (
            <Link to="/basket" className="nav-cart">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
              {totalItems > 0 && <span className="cart-badge">{totalItems}</span>}
            </Link>
          )}
          {user ? (
            <div className="nav-user">
              <Link to={user.role === 'admin' ? '/admin' : '/account'} className="nav-account">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                <span>{user.full_name.split(' ')[0]}</span>
              </Link>
              <button onClick={handleLogout} className="nav-logout">Sign out</button>
            </div>
          ) : (
            <div className="nav-auth">
              <Link to="/login" className="nav-link">Login</Link>
              <Link to="/register" className="btn-primary btn-sm">Register</Link>
            </div>
          )}
          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span/><span/><span/>
          </button>
        </div>
      </div>
    </nav>
  );
}
